import Scrollbar from 'smooth-scrollbar';

let anchors = document.querySelector('#anchors');

if (anchors) {
    Scrollbar.init(anchors, {
        alwaysShowTracks: true
    });
}
